import type { FaireProductEntity } from "../../entity_types/product";

export const p_cyjxeahx2g: FaireProductEntity = {
  token: "p_cyjxeahx2g",
  type: "product",
  name: "HELLO KITTY 12OZ STRAW TUMBLER W MOLDED HEAD TOPPER, HBUD",
  brandToken: "b_gk6kg6d4dw",
  brandName: "JOIA ACCESSORIES",
  imageUrl:
    "https://cdn.faire.com/fastly/8f434be1977468fb993593f93c8881ab08f3ba356c4c6bfbe7f8471c4f72a4da.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.7,
  description:
    'HELLO KITTY 12OZ STRAW TUMBLER W MOLDED HEAD TOPPER Item Size: 2.25" x 2.75" x 7.5"',
  tags: [],
  msrpDollars: 19.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:48.755Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
